export default "__VITE_ASSET__C5q2IzY9__"